/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Spin } from 'antd'
import './index.scss'
import { getOwnerApi, getTokenAgainApi, deleteTokenApi } from '@/services/login'
import { getCustomizationData } from '@/services/common'
import AnnouncementModal from './_components/announcementModal'
import favicon from '@/assets/images/favicon.png'
import { PwdValidStatus, MFA_VERIFY_TYPE } from '@/config/default'
import YDstatistics from '@/utils/statistics'
import { DOWNLOAD_APP_PATH } from '@/routers/login'
import MFAModal from './_components/mfaModal'
import MandatoryMFABinding from './_components/mandatoryMFABinding'
import user from '@/utils/user'
import { Origin, loginSuccess } from '@/utils/utils'
import YundingLogin from './_components/yundingLogin'
import CustomLogin from './_components/customLogin'
import type { UserInfo } from '@/services/login/types'
import type { CustomizationData } from '@/services/common/types'
import { useLoginStore } from '@/store/loginStore'
import { useUserStore } from '@/store/userStore'
import { feishuLogin } from '@/services/login'

const mobile = window.screen.width < 768

const Login = () => {
  const [customizationEnableInterface, setCustomizationEnableInterface] = useState(false) // 是否接口报错默认是租户
  const [loading, setLoading] = useState(true) // 加载中
  const [announcementVisible, setAnnouncementVisible] = useState(false) // 公告弹窗显隐
  const [mfaVisible, setMfaVisible] = useState(false) // 多因子认证弹窗显隐
  const [mfaBindVisible, setMfaBindVisible] = useState(false) // 多因子绑定弹窗显隐
  const [customizationData, setCustomizationData] = useState<CustomizationData>()  // 自定义数据

  const [searchParams] = useSearchParams()
  // const login = useSelector((state: RootState) => state.login)
  const { loginStatus } = useLoginStore()
  const { userData } = useUserStore()

  useEffect(() => {
    let localuserData = user.get()
    let numbers = window.localStorage.getItem('numbers') // 计算打开的标签页数量
    const sesTime = window.sessionStorage.getItem('sesTime')
    const localTime = window.localStorage.getItem('localTime') // 首次登录的时间
    if (searchParams.get('tokenType')) {
      user.update({
        accessToken: searchParams.get('accessToken'),
        tokenType: searchParams.get('tokenType')
      })
      getOwnerApi().then(res => {
        let data: UserInfo = {
          ...res,
          authorities: res.authorities?.map(v => {
            return v.authority
          }).join(',') || '',
          roles: res.roles?.map(v => {
            return v.role
          }).join(',') || '',
          accessToken: searchParams.get('accessToken'),
          tokenType: searchParams.get('tokenType'),
        }
        // 添加是否强制重置密码功能
        const { pwdValidStatus } = data
        if (pwdValidStatus && pwdValidStatus !== PwdValidStatus.NORMAL) {
          user.stagingUserInfo(data) // 暂存user信息
        } else {
          updateToken(data)
        }
      })
    } else {
      // 有登录store、userdata及标签页未全部关闭当前页面时进入跳转
      // 就是当前页面已登录，再开一个(复制)标签页时执行自动登录
      console.log('login,', loginStatus, userData, !((sesTime === null || sesTime === 'NaN' || localTime === null || localTime === 'NaN') && parseInt(numbers, 10) <= 0))
      if (loginStatus && userData && !((sesTime === null || sesTime === 'NaN' || localTime === null || localTime === 'NaN') && parseInt(numbers, 10) <= 0)) {
        user.stagingUserInfo(userData) // 暂存user信息
        const { pwdValidStatus } = localuserData
        if (pwdValidStatus && pwdValidStatus !== PwdValidStatus.NORMAL) {
          // 添加是否强制重置密码功能  ？自动登录的流程是否需要强制重置密码？ 目前线上不需要 先保持原状
        } else {
          const authCode = searchParams.get('code')
          if (authCode) {
            deleteTokenApi()
          } else {
            // 已经登录- token更新token 再跳转，token不能更新，直接退出，
            updateToken(userData)
          }
        }
      }
    }
    getCustomization()
    // 2026/10/30 高辰龙：销售投诉手机端无法打开WEB网页，所以这里注释掉跳转下载地址的代码，项目本身未做移动端的适配，样式乱就乱（原话）
    // if (mobile) {
    //   // 移动端访问直接跳转下载地址
    //   window.location.href = `${Origin()}${DOWNLOAD_APP_PATH}/`
    // }

    popmartFeishuLogin()
  }, [])

  // 泡泡玛特飞书自动登录 泡泡玛特为之前定制需求，appId写死的， web9.2.0之后飞书登录改为通用版本，appId从配置中获取，但现在仍需要兼容泡泡玛特登录，所以这里需要判断是否是泡泡玛特登录
  const popmartFeishuLogin = async () => {
    if (window?.h5sdk) {
      // 飞书应用内免密登录
      window.h5sdk.ready(() => {
        window.tt.requestAuthCode({
          appId: 'cli_a5e327ec6178100c',
          success: (info) => {
            console.log('feishu sucess', info.code)
            feishuLogin({ authCode: info.code, enterpriseCode: 'bl5j6yzu', authType: 'SSO' })
              .then(res => {
                if (res && res.status) {
                  loginSuccess(res.loginResponse)
                }
              })
          },
          fail: (error) => {
            console.log(error)
          }
        })
      })
    }
  }

  const updateToken = (userData) => { // 自动登陆之前刷新token之后再跳转H5项目
    if (window.h5sdk) {
      // 飞书不自动登录
      const localuserData = userData || user.get()
      if (localuserData) {
        user.remove()
      }
    } else {
      const localuserData = userData || user.get()
      getTokenAgainApi(localuserData && localuserData.accessToken).then(res => {
        if (localuserData.mfaVerifyStatus === MFA_VERIFY_TYPE.NEED) {
          setMfaVisible(true)
        } else if (localuserData.mfaVerifyStatus === MFA_VERIFY_TYPE.NO_BOUND) {
          setMfaBindVisible(true)
        } else {
          loginSuccess(res)
        }
      })
    }
  }

  // 定制化配置
  const getCustomization = async () => {
    setLoading(true)
    try {
      setLoading(true)
      const res = await getCustomizationData()
      let { platformName, addressBarLogo, customizationEnable, loginPageLogoName } = res
      if (customizationEnable) {
        setCustomizationData(res)
        window.document.title = platformName
        changeFavicon(addressBarLogo)
      } else {
        setCustomizationData(res)
        window.document.title = '云盯360'
        changeFavicon(favicon)
        // checkAnnouncement()
      }
    } catch (error) {
      setCustomizationEnableInterface(true)
      // 租户平台，服务器崩掉时URL不显示云盯的logo；
      changeFavicon(favicon)
    } finally {
      setLoading(false)
    }
  }

  // 改变favicon
  const changeFavicon = (link: string) => {
    let $favicon: HTMLLinkElement | null = window.document.querySelector('link[rel="shortcut icon"]')
    if ($favicon !== null) {
      $favicon.href = link
    } else {
      $favicon = document.createElement('link') as HTMLLinkElement
      $favicon.rel = 'shortcut icon'
      $favicon.href = link
      document.head.appendChild($favicon)
    }
  }

  /** MFA登录流程 */
  const handleMfaLogin = (data) => {
    const { account, enterprise: { abbrName }, mfaVerifyStatus } = data
    console.log('MFA登录流程', mfaVerifyStatus)
    // 当前账号在之前设置过免验证登录但是又解绑了，那么需要先删除之前的免验证登录缓存
    const key = `${abbrName}_${account}`
    const validDaysMap = JSON.parse(localStorage.getItem('react_mfa_valid_days'))

    if (validDaysMap && validDaysMap[key]) {
      delete validDaysMap[key]
      localStorage.setItem('react_mfa_valid_days', JSON.stringify(validDaysMap))
    }

    if (mfaVerifyStatus === MFA_VERIFY_TYPE.NEED) {
      setMfaVisible(true)
    } else if (mfaVerifyStatus === MFA_VERIFY_TYPE.NO_BOUND) {
      setMfaBindVisible(true)
    }
  }

  /** 关闭MFA登录验证弹窗 */
  const hideMFAModal = () => {
    setMfaVisible(false)
    setMfaBindVisible(false)
  }

  /** MFA登录验证成功 */
  const handleMFAConfirm = async () => {
    hideMFAModal()
    const data = user.getStagingUserInfo()
    loginSuccess(data)
    // const userData = user.get()
    // user.update(data)
    // loginUtils.login()
    // if (userData && userData.enterprise && userData.enterprise.grayId) {
    //   await changeLangApi()
    //   window.location.href = `${Origin()}/${userData.enterprise.nameMap[userData.enterprise.grayId]}/`
    // } else {
    //   window.location.href = `${Origin()}/${VersonGray}/`
    // }
  }

  // 改变公告弹窗显隐
  const changeAnnouncementVisible = (val) => {
    setAnnouncementVisible(val)
  }

  // 检测路由地址，自动打开维护公共弹窗
  const checkAnnouncement = () => {
    if (customizationEnableInterface || customizationData?.customizationEnable) return
    if (window.location.href.indexOf('maintenance') > -1) {
      changeAnnouncementVisible(true)
    }
  }

  return (
    <Spin spinning={loading}>
      {customizationEnableInterface // 接口报错默认是租户
        ? <CustomLogin customizationData={customizationData} handleMfaLogin={handleMfaLogin} />
        : (
          customizationData?.customizationEnable // 接口正常在判断租户和云盯
            ? !loading && <CustomLogin customizationData={customizationData} handleMfaLogin={handleMfaLogin} />
            : !loading && <YundingLogin handleMfaLogin={handleMfaLogin} mfaVisible={mfaVisible} />
        )
      }
      {/* 公告弹窗 */}
      <AnnouncementModal
        visible={announcementVisible}
        onCancel={() => changeAnnouncementVisible(false)}
      />
      {/* MFA登录验证 */}
      <MFAModal visible={mfaVisible} onCancel={hideMFAModal} onConfirm={handleMFAConfirm} />
      {/* 强制绑定MFA弹窗 */}
      <MandatoryMFABinding visible={mfaBindVisible} onCancel={hideMFAModal} onConfirm={handleMFAConfirm} />
    </Spin>
  )
}

export default YDstatistics(Login)
